import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { toast } from 'react-toastify';
import { leaveSessionAction } from "CONFIG/ActionFactory";

import * as log from "loglevel";

import MainLayout from "./MainLayout";
import { handleMessage as handleChatMessage } from "WEBSOCKET/Chat/ChatMessageHandler";
import { handleMessage as handleSessionMessage } from "WEBSOCKET/Session/SessionMessageHandler";
import { handleMessage as handleWhiteboardMessage } from "WEBSOCKET/Whiteboard/WhiteboardMessageHandler";
import { handleMessage as handleSharedMediaMessage } from "WEBSOCKET/SharedMedia/SharedMediaMessageHandler";
import { handleMessage as handleParticipantMessage } from "WEBSOCKET/Participant/ParticipantMessageHandler";
import { handleMessage as handleNotificationMessage } from "WEBSOCKET/Notification/NotificationMessageHandler";
import { handleMessage as handleLocationMessage } from "WEBSOCKET/Location/LocationMessageHandler";
import { handleMessage as handleAppEmulationMessage } from "WEBSOCKET/AppEmulation/AppEmulationHandler";
import { handleMessage as handleErrorMessage } from "WEBSOCKET/Error/ErrorMessageHandler";
import { handleMessage as handleCustomerCoBrowseMessage } from "WEBSOCKET/CustomerCoBrowse/CustomerCoBrowseHandler";
import { handleMessage as handleSupportCenterMessage } from "WEBSOCKET/SupportCenter/SupportCenterHandler";

import { socketMessage } from "WEBSOCKET/constants";
import {
  initSocketWorker,
  connectWebsocket,
  disconnectWebsocket,
  sendWebsocketMessage
} from "WEBSOCKET/WebsocketHandler";
import {
  initSocketWorker as initSupportCenterSocketWorker,
  connectWebsocket as connectSupportCenterWebsocket,
  disconnectWebsocket as disconnectSupportCenterWebsocket,
} from "WEBSOCKET/SupportCenterWebsocketHandler";

import {
  selectUserToken,
  selectUserName,
  selectWebsocketUrl,
  selectSessionKey,
  selectEndUserToken,
  selectUserDetails,
  selectSessionStatus,
  selectSessionType,
} from "./selectors";
import { getIsSessionJoined } from "../Sessions/selectors";
import { selectIsSupportCenterSessionEnded } from "REDUX/Selector/SessionSelector.js"

import { removeTrailingSlash } from "UTILS/Utility";
import { CONFIG, USER_ROLES, USER_ADMISSION_STATUS } from "UTILS/Constants";

// Actions
import { sessionActions, callWaitingAction } from "CONFIG/ActionFactory";
import { SESSION_STATUS, SESSION_SUBTYPES } from "../../Utils/Constants";
// import loadCobrowseScript from "../CommonComponents/LoadScript/LoadCobrowseScript";

export class MainLayoutContainer extends Component {
  constructor(props) {
    super(props);
    log.setLevel("error");
  }

  componentDidMount() {
    console.log("################## MainLayoutContainer componentDidMount location: ", this.props.location.pathname, ",isSessionJoinedthis:", this.props.isSessionJoined);
    //toast.removeByType("error"); //TODO: find use and apropriate solution
    //toast.removeByType("success");
    //toast.removeByType("info");
    toast.dismiss()
    this.connectWebsocket();
    this.connectSupportCenterWebsocket();
    // Do not send JOIN WS message if user is on the /startSupportCenterSession path.
    if (removeTrailingSlash(this.props.location.pathname) === CONFIG.path.startSupportCenterSession) {
      return;
    }
    if((removeTrailingSlash(this.props.location.pathname) !== CONFIG.path.startSession &&
      removeTrailingSlash(this.props.location.pathname) !== CONFIG.path.callWaiting) || 
      this.props.sessionStatus === SESSION_STATUS.WAITING){
      // send JOIN WS message if User is not on /startSession and /callWaiting path or if Session is waiting (User is on QR waiting screen)
      this.sendJoinSessionWSMessage();
    } 
    
    //this.wsocket.on(socketMessage.events.MESSAGE, this.handleWebsocketMessage);
    // this.wsocket.on("disconnect", reason => {
    //   if (this.props.isSessionJoined && reason !== "io client disconnect") {
        
    //     sessionActions.isSessionJoinedAction(false);
    //     this.props.history.push(CONFIG.path.reJoin);
    //   }
    // });
  }

  componentDidUpdate(prevProps) {
    if(prevProps.currentUserDetails.admissionStatus != this.props.currentUserDetails.admissionStatus
      && this.props.currentUserDetails.admissionStatus === USER_ADMISSION_STATUS.ADMITTED) {
      if (!(removeTrailingSlash(this.props.location.pathname) === CONFIG.path.startSession && this.props.currentUserDetails.role == USER_ROLES.AGENT)) {
        // not startSession or startSession and guest
        this.sendJoinSessionWSMessage();
      }
    }
    if(prevProps.endUserToken != this.props.endUserToken) {
      this.connectWebsocket();
    }
    if ((prevProps.isSupportCenterSessionEnded != this.props.isSupportCenterSessionEnded)
        && this.props.isSupportCenterSessionEnded
    ){
      let isUserEvictedPage = window.location.pathname === `${this.props.uriIdentifier}${CONFIG.path.userEvicted}`
      let participantLeftPayload = {
        data: {
          category: socketMessage.category.PARTICIPANT,
          action: socketMessage.subCategories.PARTICIPANT.LEFT,
          sessionKey: this.props.sessionKey,
          isParticipantEvicted: isUserEvictedPage ? true : false
        }
      };
      this.props.sendWebsocketMessage(
        socketMessage.events.MESSAGE,
        participantLeftPayload
      );
      this.wsocket = null;
      this.props.disconnectWebsocket();
      sessionStorage.removeItem(this.props.endUserToken);
      leaveSessionAction.localSessionAllDataCleanUp();
      leaveSessionAction.setIsSupportCenterSessionEnded(false);
    }
    if ((prevProps.isSupportCenterSessionEnded != this.props.isSupportCenterSessionEnded)
        && !this.props.isSupportCenterSessionEnded
    ){
      this.connectWebsocket();
    }
  }

  connectWebsocket = () => {
    console.log("connectWebsocket");
    if(this.props.endUserToken) {
      initSocketWorker();
      this.wsocket = connectWebsocket(
        window._env_.REACT_APP_LOOOKIT_WEB_SOCKET_URL,
        this.props.endUserToken,
        this.handleWebsocketMessage,
        this.socketDisconnected
      );
    }
  }

  connectSupportCenterWebsocket = () => {
    console.log("connectSupportCenterWebsocket");
    if ((removeTrailingSlash(this.props.location.pathname) === CONFIG.path.callWaiting
      || ((removeTrailingSlash(this.props.location.pathname) === CONFIG.path.dashboard)
      && this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER && this.props.currentUserDetails.role == USER_ROLES.AGENT))
      && this.props.userToken) {
      // On the callWaiting page, since the operator has not yet participated in the session,
      // the operator connects using the token received at login.
      initSupportCenterSocketWorker();
      this.supportCenterWsocket = connectSupportCenterWebsocket(
        window._env_.REACT_APP_LOOOKIT_WEB_SOCKET_URL,
        this.props.userToken,
        this.handleWebsocketMessage,
        this.socketDisconnected,
        this.socketConnectError,
        this.webWorkerError,
      );
    }
  };

  sendJoinSessionWSMessage = () => {
    const { store, userName, sessionKey, websocketUrl, userToken, endUserToken, currentUserDetails } = this.props;
    let sessionJoinPayload = {
      data: {
        category: socketMessage.category.SESSION,
        action: (currentUserDetails == USER_ROLES.AGENT 
          || currentUserDetails.admissionStatus == USER_ADMISSION_STATUS.ADMITTED 
          ?  socketMessage.subCategories.SESSION.JOIN 
          : socketMessage.subCategories.SESSION.JOIN_SESSION_REQUEST),
        userName: userName,
        sessionKey: sessionKey,
        token: endUserToken
      }
    };
    if (userToken) {
      sessionJoinPayload.data.token = userToken;
    }
    this.props.sendWebsocketMessage(
      socketMessage.events.MESSAGE,
      sessionJoinPayload
    );
  }

  // Chrome: control doesn't come here on refresh
  // FF: control comes here on refresh
  // controls comes here when browser is kept in background and sockect is disconnected 
  // So when user comes back to the browser page, need to rejoin   
  socketDisconnected = reason => {
    console.log("################, in MainLayoutContainer socketDisconnected", this.props.isSessionJoined);
    if (this.props.isSessionJoined && reason !== "io client disconnect") {
      sessionActions.isSessionJoinedAction(false);
      // User does not move from the startSupportCenterSession screen to the rejoin screen.
      if (removeTrailingSlash(this.props.location.pathname) === CONFIG.path.startSupportCenterSession) {
        sessionActions.isDisconnectedWhileCallingAction(true);
        return;
      }
      console.log("################, in MainLayoutContainer socketDisconnected... rejoining");
      this.props.history.push(CONFIG.path.reJoin);
    }
    if (removeTrailingSlash(this.props.location.pathname) === CONFIG.path.callWaiting
    && reason !== "io client disconnect") {
      this.props.history.push(CONFIG.path.serverUnreachable);
    }
  }

  socketConnectError = reason => {
    if (removeTrailingSlash(this.props.location.pathname) === CONFIG.path.callWaiting
    && reason !== "io client disconnect") {
      this.props.history.push(CONFIG.path.serverUnreachable);
    }
  };

  webWorkerError = () => {
    if (removeTrailingSlash(this.props.location.pathname) === CONFIG.path.callWaiting) {
      callWaitingAction.setIsWebWorkerError(true);
    }
  };

  componentWillUnmount() {
    console.log("################, in MainLayoutContainer... componentWillUnmount");
    if (removeTrailingSlash(this.props.location.pathname) === CONFIG.path.callWaiting
    && this.props.userToken) {
      this.supportCenterWsocket = null;
      this.props.disconnectSupportCenterWebsocket();
    }
    if(this.props.endUserToken) {
      let isUserEvictedPage = window.location.pathname === `${this.props.uriIdentifier}${CONFIG.path.userEvicted}`
      let participantLeftPayload = {
        data: {
          category: socketMessage.category.PARTICIPANT,
          action: socketMessage.subCategories.PARTICIPANT.LEFT,
          sessionKey: this.props.sessionKey,
          isParticipantEvicted: isUserEvictedPage ? true : false
        }
      };
      this.props.sendWebsocketMessage(
        socketMessage.events.MESSAGE,
        participantLeftPayload
      );
      this.wsocket = null;
      this.props.disconnectWebsocket();
      leaveSessionAction.localSessionAllDataCleanUp();
      sessionStorage.removeItem(this.props.endUserToken);
    }
  }
  handleWebsocketMessage = data => {
    const { store } = this.props;

    switch (data.data.category) {
      case socketMessage.category.ERROR:
        if(data.data.errorType === socketMessage.subCategories.ERROR.UNAUTHORIZED_ERROR) {
          this.props.history.push(CONFIG.path.failedToken);
        }
        break;
      case socketMessage.category.CHAT:
        handleChatMessage(data.data, store);
        break;
      case socketMessage.category.SESSION:
        handleSessionMessage(data.data, store);
        break;
      case socketMessage.category.PDF:
      case socketMessage.category.WHITEBOARD:
        handleWhiteboardMessage(data.data, store);
        break;
      case socketMessage.category.WEBRTC:
        handleSharedMediaMessage(data.data, store);
        break;
      case socketMessage.category.PARTICIPANT:
        handleParticipantMessage(data.data, store);
        break;
      case socketMessage.category.NOTIFICATION:
        handleNotificationMessage(data.data, store);
        break;
      case socketMessage.category.LOCATION:
        handleLocationMessage(data.data, store);
        break;
      case socketMessage.category.APP_EMULATION:
        handleAppEmulationMessage(data.data, store);
        break;
      case socketMessage.category.CUSTOMER_CO_BROWSE:
        handleCustomerCoBrowseMessage(data.data, store);
        break;
      case socketMessage.category.ERROR:     
        handleErrorMessage(data.data, store)
        break;
      case socketMessage.category.SUPPORT_CENTER:
        handleSupportCenterMessage(data.data, store);
        break;
    }
  };

  render() {
    return (
      <div>
        <MainLayout
          children={this.props.children}
          history={this.props.history}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    SessionReducer: state.SessionReducer,
    userToken: selectUserToken(state),
    userName: selectUserName(state),
    websocketUrl: selectWebsocketUrl(state),
    sessionKey: selectSessionKey(state),
    isSessionJoined: getIsSessionJoined(state),
    endUserToken: selectEndUserToken(state),
    activeCanvas: state.WhiteboardReducer.activeCanvas,
    sessionStatus: selectSessionStatus(state),
    currentUserDetails: selectUserDetails(state),
    sessionType: selectSessionType(state),
    isSupportCenterSessionEnded: selectIsSupportCenterSessionEnded(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      disconnectWebsocket,
      sendWebsocketMessage,
      disconnectSupportCenterWebsocket,
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MainLayoutContainer)
);
